import { render, staticRenderFns } from "./pendo-consent-dialog.vue?vue&type=template&id=49aa5fe8&"
import script from "./pendo-consent-dialog.vue?vue&type=script&lang=tsx&"
export * from "./pendo-consent-dialog.vue?vue&type=script&lang=tsx&"
import style0 from "./pendo-consent-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports